import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { ProductService } from '../Services/product';
import { ColorService } from '../Services/color';
import { FabricService } from '../Services/fabric';
import { CollectionService } from '../Services/collection';
import { CategoryService } from '../Services/category';
import { Product } from '../Models/product';
import { Category } from '../Models/category';
import { Color } from '../Models/color';
import { Fabric } from '../Models/fabric';
import { Collection } from '../Models/collection';
import { ProductFilter } from '../Models/filter';
import { Page } from '../Models/page';
import { Location } from '@angular/common';
import { GoogleAnalyticsEventsService } from "../Services/google-analytics";


@Component({
  selector: 'list-products',
  templateUrl: '../Templates/product.list.html',
})


export class ProductListComponent implements OnInit {

  products: Page<Product>;
  filter: ProductFilter;
  sideBarIsOpenOnMobile = false;

  constructor(protected route: ActivatedRoute,
              protected router: Router,
              public productService: ProductService,
              protected location: Location,
              protected gaEventsService: GoogleAnalyticsEventsService,
             ) { }

  /**
   * Handle user activated change in filter settings.
   */
  public handleFilterChange(arg): void {

    this.filter = arg;

    this.getProducts();

    let params = this.productService.getParamsFromFilter(this.filter);

    // notify google analytics about this filter change event
    this.gaEventsService.emitEvent(
      "Filter Shop", params.toString(), "filter has changed")

    // todo: hardcoded 'shop' from route?
    // this.location.replaceState(`/shop?${params.toString()}`);
    this.location.go(`/shop?${params.toString()}`);
  }

  public handlePageChange(params: string): void {

    this.router.navigateByUrl(`/shop?${params}`);
  }

  public handleSearch(query): void {

    this.filter.setval('query', query);
    this.handleFilterChange(this.filter);
  }

  protected getProducts(): void {

    this.productService.list(this.filter)
      .subscribe(data => {
        this.products = data;
      })
  }

  applyFiltering(params: ParamMap) {

    this.filter.clearAll();

    for (let p of params.keys) {
      if (p === 'search') {
        this.filter.setval('query', params.get(p));
      } else {
        for (let v of params.getAll(p)) {
          this.filter.setval(p, v);
        }
      }
    }
    this.getProducts();
  }

  ngOnInit() {

    // scroll window to top. Schijnt in toekomstge angular versie
    // misschien niet meer nodig te zijn?
    window.scrollTo(0, 0);

    this.filter = new ProductFilter();

    this.location.subscribe(
      () => {
        this.applyFiltering(this.route.snapshot.queryParamMap);
      }
    );

    this.route.queryParamMap.subscribe((params: ParamMap) => {
        this.applyFiltering(params);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/product.list.ts